import { graphql, operation } from "../lib/graphql";
import { Publissue } from ".";

const GetMeQuery = operation(
  graphql(`
    query GetMe {
      viewer {
        id
        login
        email
      }
    }
  `),
).withMap((data) => data.viewer);

export async function getMe(this: Publissue) {
  return this.graphql(GetMeQuery).execute();
}
